import { Typography } from "@plum-xoxo/admin-dsm";
import React from "react";
import styled from "styled-components";
import ExploreMarketPlaceBlock from "../SelectCampaign/ExploreMarketPlaceBlock";
import { Modal, ModalHeader } from "reactstrap";
const StyledModal = styled(Modal).attrs()`
  width: 716px;
  padding: 0;
  .modal-header {
    .modal-title {
      display: flex;
      flex-direction: column;
      align-items: start;
      margin: 0;
    }
  }
`;
const SetDomainModal = ({
  history,
  updateEmployeeDetails,
  updatePlatformSettings,
}) => {
  return (
    <StyledModal isOpen size="lg">
      <ModalHeader
        toggle={() => {
          history.goBack();
        }}
        closeButton
        charCode={<img src="/admin/img/svg-icons/closeIcon.svg" />}
      >
        <Typography.H3>Set Redemption Marketplace</Typography.H3>
        <Typography.BodySmall className="mb-0">
          Set the marketplace URL to enable platform settings.
        </Typography.BodySmall>
      </ModalHeader>
      <hr className="my-0" />
      <ExploreMarketPlaceBlock
        fromSettings
        updateEmployeeDetails={updateEmployeeDetails}
        updatePlatformSettings={updatePlatformSettings}
      />
    </StyledModal>
  );
};

export default SetDomainModal;
